/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_Error_Transfer_LimitInputs */



/**
* | output |
* | --- |
* | "You've moved this licence 4 times in the last 12 months. Contact support to move it again." |
*
* @param {License_Error_Transfer_LimitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_error_transfer_limit = /** @type {((inputs?: License_Error_Transfer_LimitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_Error_Transfer_LimitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous avez déplacé cette licence 4 fois en 12 mois. Contactez l'assistance pour la déplacer de nouveau.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie haben diese Lizenz in 12 Monaten 4-mal übertragen. Wenden Sie sich für eine weitere Übertragung an den Support.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Hai spostato questa licenza 4 volte in 12 mesi. Contatta il supporto per spostarla di nuovo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Лицензию переносили 4 раза за 12 месяцев. Для нового переноса обратитесь в поддержку.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Has movido esta licencia 4 veces en 12 meses. Contacta con soporte para moverla de nuevo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("此许可证在过去 12 个月内已转移 4 次。如需再次转移，请联系支持团队。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("過去 12 か月で 4 回移行済みです。再度移行するにはサポートにお問い合わせください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आपने पिछले 12 महीनों में यह लाइसेंस 4 बार स्थानांतरित किया है। फिर से करने के लिए सहायता से संपर्क करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Moveu esta licença 4 vezes nos últimos 12 meses. Contacte o suporte para a mover novamente.")
	return /** @type {LocalizedString} */ ("You've moved this licence 4 times in the last 12 months. Contact support to move it again.")
});